import { useCallback } from "react";
import Button from "modules/Core/sub-modules/ui-kit/components/Button";
import strappedConnected from "modules/Core/higher-order-components/strappedConnected";
import cells from "modules/cycles/state/index";

export default strappedConnected(
    Button,
    {},
    { add: cells.addGatewayToActiveCycle.action },
    ({ gatewayId, cycle, add, refetchGateway }) => {
        const inCycle = Boolean(cycle?.id);
        return {
            text: inCycle ? "In cycle" : "Add to Cycle",
            disabled: inCycle,
            onClick: useCallback(() => {
                if (inCycle) return;
                add({ gatewayId, callback: refetchGateway });
            }, [add, gatewayId, inCycle, refetchGateway]),
        };
    }
);
